import { makeStyles, Typography } from "@material-ui/core"
import { FC } from "react"
import clsx from "clsx"
import { NudgeDomain } from "../../utils/constants"
import { colors } from "../../utils/theme"

const useStyles = makeStyles((theme) => ({
  bar: {
    height: 12,
    backgroundColor: colors.neutral.clay,
    borderTopRightRadius: 32,
    borderBottomRightRadius: 32,
    marginRight: 4,
  },
  circle: {
    height: 8,
    width: 8,
    borderRadius: "50%",
    marginRight: theme.spacing(1),
  },
  technique: {},
  techniques: {
    paddingRight: theme.spacing(3),
    borderRight: `0.5px solid ${colors.neutral.clay}`,
  },
  innerTechnique: {
    marginBottom: 14,
  },
  techniqueLabel: {
    fontWeight: 400,
    color: colors.neutral.denim,
  },
  techniqueLabelContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: 4,
  },
  techniquePercent: {
    margin: 0,
    padding: 0,
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: 10,
    letterSpacing: 0.3,
    color: colors.neutral.space_08,
  },
  techniquePercentContainer: {
    display: "flex",
    alignItems: "center",
  },
}))

export const Technique: FC<{
  label: string
  domain: NudgeDomain
  percent: number
  width: string | number
  className?: string
}> = ({ label, domain, percent, width, className }) => {
  const classes = useStyles()
  return (
    <div className={clsx(classes.technique, className)}>
      <div className={classes.techniqueLabelContainer}>
        <div
          className={classes.circle}
          style={{ backgroundColor: colors.schedule[domain]?.border ?? "" }}
        />
        <Typography variant="body2" className={classes.techniqueLabel}>
          {label}
        </Typography>
      </div>
      <div className={classes.techniquePercentContainer}>
        <div className={classes.bar} style={{ width }} />
        <p className={classes.techniquePercent}>{Math.trunc(percent * 100)}%</p>
      </div>
    </div>
  )
}

export const TechniqueListWithPercentage: FC<{
  techniques:
    | {
        label: string
        domain: NudgeDomain
        percent: number
        active?: boolean
      }[]
    | undefined
  percentMultiplier: number
}> = ({ techniques, percentMultiplier }) => {
  const classes = useStyles()
  return (
    <>
      {techniques &&
        techniques.map((technique, index, array) => (
          <Technique
            key={technique.label}
            {...technique}
            width={
              index === 0
                ? "100%"
                : `${Math.trunc(technique.percent * percentMultiplier * 100)}%`
            }
            className={
              index < array.length - 1 ? classes.innerTechnique : undefined
            }
          />
        ))}
    </>
  )
}
